import { render, staticRenderFns } from "./prevision-bills.vue?vue&type=template&id=6f00480d&class=spacer-bottom-xl&"
import script from "./prevision-bills.vue?vue&type=script&lang=js&"
export * from "./prevision-bills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports